import Vue from "vue";
import Buefy from "buefy";
import ProductDetail from "./App.vue";

import ProductDetailForm from "./components/ProductDetailForm.vue"
import ImagesForm from "./components/ImagesForm.vue"
import AttrForm from "./components/AttrForm.vue"
import AttrFormEl from "./components/AttrFormEl.vue"
import AttrAddForm from "./components/AttrAddForm.vue"
import VariantsForm from "./components/VariantsForm.vue"
import VariantsFormEl from "./components/VariantsFormEl.vue"
import Inventory from "./components/Inventory.vue"


Vue.use(Buefy, {
  defaultIconPack: 'fas',
})
Vue.use(ProductDetail)

Vue.use(ProductDetailForm)
Vue.use(ImagesForm)
Vue.use(AttrForm)
Vue.use(AttrFormEl)
Vue.use(AttrAddForm)
Vue.use(VariantsForm)
Vue.use(VariantsFormEl)
Vue.use(Inventory)

if(document.getElementById("productDetailApp")){
    new Vue({
        render: h => h(ProductDetail, {
            props:{
                productDetailEndpoint:document.getElementById("productDetailApp")
                    .getAttribute("product-detail-endpoint"),
                taxEndpoint:document.getElementById("productDetailApp")
                    .getAttribute("tax-endpoint"),
                currencyEndpoint:document.getElementById("productDetailApp")
                    .getAttribute("currency-endpoint"),
                subcategoryEndpoint:document.getElementById("productDetailApp")
                    .getAttribute("subcategory-endpoint"),
                imagesList:document.getElementById("productDetailApp")
                    .getAttribute("images-list-endpoint"),
                imagesCreate:document.getElementById("productDetailApp")
                    .getAttribute("image-create"),
                imagesDelete:document.getElementById("productDetailApp")
                    .getAttribute("image-delete"),
                imagesUpdate:document.getElementById("productDetailApp")
                    .getAttribute("image-update"),
                attributesList:document.getElementById("productDetailApp")
                    .getAttribute("attr-list"),
                attributesDetail:document.getElementById("productDetailApp")
                    .getAttribute("attr-detail"),
                attrValDetail:document.getElementById("productDetailApp")
                    .getAttribute("attr-val-detail"),
                attrValCreate:document.getElementById("productDetailApp")
                    .getAttribute("attr-val-create"),
                attrandvalCreate:document.getElementById("productDetailApp")
                    .getAttribute("attrandval-create"),
                variantDetail:document.getElementById("productDetailApp")
                    .getAttribute("variant-detail"),
                variantCreate:document.getElementById("productDetailApp")
                    .getAttribute("variant-create"),
                variantList:document.getElementById("productDetailApp")
                    .getAttribute("variant-list"),
                movementList:document.getElementById("productDetailApp")
                    .getAttribute("movements"),
                skuList:document.getElementById("productDetailApp")
                    .getAttribute("sku-list"),
                skuCreate:document.getElementById("productDetailApp")
                    .getAttribute("sku-create"),
                movementAdd:document.getElementById("productDetailApp")
                    .getAttribute("movement-add"),
                movementDestroy:document.getElementById("productDetailApp")
                    .getAttribute("movement-destroy"),
                filtersEndpoint: document.getElementById("productDetailApp")
                    .getAttribute("filters-list-create")
            }
        })
    }).$mount('#productDetailApp')
}